import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual, omit } from '../../utils/object';
var ImageBoundsWrapper = /*#__PURE__*/function (_Component) {
  function ImageBoundsWrapper(_props) {
    var _this;
    _classCallCheck(this, ImageBoundsWrapper);
    _this = _callSuper(this, ImageBoundsWrapper, [_props]);
    _this.state = {
      layout: {
        width: 0,
        height: 0
      },
      offset: {
        top: 0,
        left: 0
      },
      optical: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      nine: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      content: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: 0,
        width: 0
      }
    };
    _this._runCalc = function (props) {
      var _props$ibw = props.ibw,
        orig_dimensions = _props$ibw.dimensions,
        orig_optical = _props$ibw.optical,
        orig_nine = _props$ibw.nine,
        orig_content = _props$ibw.content;
      var manualAssetScale = props.manualAssetScale;
      var dimensions = JSON.parse(JSON.stringify(orig_dimensions));
      var optical = JSON.parse(JSON.stringify(orig_optical));
      var nine = orig_nine ? JSON.parse(JSON.stringify(orig_nine)) : undefined;
      var content = orig_content ? JSON.parse(JSON.stringify(orig_content)) : {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      };
      if (manualAssetScale) {
        dimensions.height *= manualAssetScale;
        dimensions.width *= manualAssetScale;
        optical.top *= manualAssetScale;
        optical.left *= manualAssetScale;
        optical.right *= manualAssetScale;
        optical.bottom *= manualAssetScale;
        content.top *= manualAssetScale;
        content.left *= manualAssetScale;
        content.right *= manualAssetScale;
        content.bottom *= manualAssetScale;
        if (nine) {
          nine.top *= manualAssetScale;
          nine.left *= manualAssetScale;
          nine.right *= manualAssetScale;
          nine.bottom *= manualAssetScale;
        }
      }
      if (nine) {
        var opticalMultiplier = props.opticalMultiplier ? props.opticalMultiplier : 1;
        optical.top /= opticalMultiplier;
        optical.left /= opticalMultiplier;
        optical.right /= opticalMultiplier;
        optical.bottom /= opticalMultiplier;
        content.top /= opticalMultiplier;
        content.left /= opticalMultiplier;
        content.right /= opticalMultiplier;
        content.bottom /= opticalMultiplier;
      }
      var layout = {
        width: dimensions.width - optical.right - optical.left,
        height: dimensions.height - optical.bottom - optical.top
      };
      var offset = {
        top: -optical.top,
        left: -optical.left
      };
      var insets = nine;
      if (!nine) {
        if (props.height) {
          var h = props.height;
          if (typeof props.height === 'string') {
            h = props.height.split('%')[0];
            h /= 100;
            h *= props.parent.height;
          }
          var ratio = h / layout.height;
          offset.top *= ratio;
          layout.height = dimensions.height * ratio;
        }
        if (props.width) {
          var w = props.width;
          if (typeof props.width === 'string') {
            w = props.width.split('%')[0];
            w /= 100;
            w *= props.parent.width;
          }
          var _ratio = w / layout.width;
          offset.left *= _ratio;
          layout.width = dimensions.width * _ratio;
        }
      } else {
        if (props.height) {
          var _h = props.height;
          var _ratio2 = _h / dimensions.height;
          layout.height = dimensions.height * _ratio2;
          layout.height += optical.top;
          layout.height += optical.bottom;
          offset.top = -optical.top;
        }
        if (props.width) {
          var _w = props.width;
          var _ratio3 = _w / dimensions.width;
          layout.width = dimensions.width * _ratio3;
          layout.width += optical.right;
          layout.width += optical.left;
          offset.left = -optical.left;
        }
      }
      _this.setState({
        layout: layout,
        offset: offset,
        optical: optical,
        nine: insets,
        content: content
      });
    };
    return _this;
  }
  _inherits(ImageBoundsWrapper, _Component);
  return _createClass(ImageBoundsWrapper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isEqual(omit(prevProps, ['navigation', 'render']), omit(this.props, ['navigation', 'render']))) {
        this._runCalc(this.props);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.render({
        optical: {
          offsetTop: this.state.offset.top,
          offsetLeft: this.state.offset.left,
          dimensions: this.state.optical
        },
        nine: this.state.nine,
        layout: {
          width: this.state.layout.width,
          height: this.state.layout.height
        },
        content: this.state.content,
        source: this.props.source
      });
    }
  }]);
}(Component);
ImageBoundsWrapper.propTypes = {
  source: PropTypes.node.isRequired,
  ibw: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  opticalMultiplier: PropTypes.number,
  parent: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  })
};
export { ImageBoundsWrapper as default };